// extracted by mini-css-extract-plugin
export default {"zoomControls":"maa-z","zoomControlButton":"naa-z","zoomBanner":"oaa-z","bannerButton":"paa-z","imageButton":"qaa-z","zoom":"raa-z","zoomContent":"saa-z"};